export default "__VITE_ASSET__5e05e2d0__"